import Axios from "../../../../api/axios/Axios";

const BASE_URL = "/api/videos";

const encode = (value) => encodeURIComponent(String(value));

export const getVideoRentalAccess = async (videoTag) => {
  const response = await Axios.get(`${BASE_URL}/${encode(videoTag)}/access`);

  return response.data;
};

export const createVideoRental = async (videoTag) => {
  const response = await Axios.post(`${BASE_URL}/${encode(videoTag)}/rent`);

  return response.data;
};

export const getMyVideoRentals = async () => {
  const response = await Axios.get("/api/users/me/rentals");

  return response.data;
};
